import { fetchJSON, fetchPublicCOACH, POST } from 'utils/http';
import { SEND_CONTACT_MAIL, ADD_COACH_APPLICATION } from 'constants/urls';

export function sendMail(body, coach_application) { // eslint-disable-line
  debugger; // eslint-disable-line
  let URL = SEND_CONTACT_MAIL;
  if (coach_application) { // eslint-disable-line
    URL = ADD_COACH_APPLICATION;
    return fetchJSON(URL, POST, {}, body, {});
  }
  return fetchPublicCOACH(URL, POST, body, {});
}

export function sendMoreNotification() {
  return fetchJSON(SEND_CONTACT_MAIL);
}



// WEBPACK FOOTER //
// ./src/common/services/mail.services/service.js